<template>
  <v-menu
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      :label="name"
      :hint="description"
      persistent-hint
      :required="Boolean( isRequired )"
      :rules="Boolean( isRequired ) ? [ rules.required ] : []"
      v-model="dateFormatted"
      @input="onInput"
      readonly
      clearable
    />
    <v-date-picker
      no-title
      :first-day-of-week="1"
      locale="ru-Ru"
      :value="currentValue" @input="onInput"
    />
  </v-menu>
</template>

<script>

import formComponent from '../mixins/form_component'
import defaultParser from '../parsers/input_parser'

export default {

  name: 'FormDate',

  mixins: [ formComponent ],

  /**
   *
   *
   */
  props: {

  },

  /**
   *
   *
   */
  data() {

    return {

      dateFormatted: '',

      // Описание поля
      description: '',

      // Обязательное поле
      isRequired: false,

      // Правила валидации
      rules: {

        required: this.validator( this.required, 'Необходимо указать дату' ),

        date: this.validator( this.required, 'Необходимо указать дату' )
      }
    }
  },

  /**
   *
   *
   */
  watch: {

    /**
     *
     *
     */
    currentValue: {

      handler( value ) {

        this.dateFormatted = this.formatDate( this.currentValue );
      },

      // Необходимо для инициализации значения по умолчанию
      immediate: true
    }
  },

  /**
   *
   *
   */
  computed: {

  },

  /**
   *
   *
   */
  methods: {

    /**
     * Инициализация компонента.
     *
     *  - подключение парсера
     *  - инициализация данных и значения по умолчанию
     *
     */
    init() {

      // Инициализация парсера.
      this.initParser( defaultParser )

      this.name = this.parser.getName( this.data )
      this.description = this.parser.getDescription( this.data )
      this.isRequired = this.parser.getRequired( this.data )
    },

    /**
     *
     *
     * @param date
     * @returns {*}
     */
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },

    /**
     *
     *
     * @param date
     * @returns {*}
     */
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/apps/bpm/components/form/FormDate.vue